import { render } from "./About.vue?vue&type=template&id=8006c308"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
script.render = render

export default script